import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SiteDetailTiltAlertService } from '../site-detail-tilt-alert/site-detail-tilt-alert.service';

@Component({
  selector: 'app-site-detail-tilt-alert-standard',
  templateUrl: './site-detail-tilt-alert-standard.component.html',
  styleUrls: ['./site-detail-tilt-alert-standard.component.scss'],
})
export class SiteDetailTiltAlertStandardComponent implements OnChanges {
  @Input() date: string = '';
  @Input() positionName: string = '';

  isOuter = false; // 外部のユーザかどうか

  constructor(private siteDetailAlertService: SiteDetailTiltAlertService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.isOuter = this.siteDetailAlertService.isOuterUser();
  }
}
